import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { getErrorMessage } from '@/utils/errorMessage';
import { subscribe } from '@/api/payment';

export const useSubscribe = (
	onSuccess?: (data: Payments.SubscriptionResponse) => void,
) => {
	const queryClient = useQueryClient();

	const subscribeMutation = useMutation({
		// Chama a função da API que definimos no passo anterior
		mutationFn: (data: Payments.SubscribeData) => subscribe(data),

		onSuccess: async (data) => {
			// Se for plano FREE, mostramos o feedback de sucesso na hora
			if (data.success) {
				toast.success(data.message || 'Plano ativado com sucesso!');
				// Invalida o cache do usuário para refletir que ele agora é membro
				await queryClient.invalidateQueries({ queryKey: ['user'] });
				await queryClient.refetchQueries({ queryKey: ['user'] });
			}

			// Executa a lógica extra (ex: redirecionar para Stripe ou Dashboard)
			if (onSuccess) onSuccess(data);
		},

		onError: (error: unknown) => {
			toast.error(getErrorMessage(error, 'Erro ao processar assinatura'));
		},
	});

	return subscribeMutation;
};
